import React, { useState, useEffect, FC } from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { SmallPanel } from 'src/common/ui/small-panel';

interface DashboardHomeSharingPanelProps
  extends Pick<
    JourneyMenuPropsInterface,
    'openRef' | 'closeRef' | 'renderOrigin' | 'onOpen' | 'onClose' | 'placement'
  > {
  onChange: (checked: boolean) => void;
  isEnabled: boolean;
  onBack: () => void;
}

export const DashboardHomeSocialSharingPanel: FC<DashboardHomeSharingPanelProps> = ({
  onChange,
  isEnabled,
  onBack,
  children,
  ...popoverProps
}) => {
  const [isSharingEnabled, setIsSharingEnabled] = useState(isEnabled);

  const onSharingChanged = (checked: boolean) => {
    setIsSharingEnabled(checked);
    onChange(checked);
  };

  return (
    <SmallPanel openAfterMount hasBackButton onBack={onBack} {...popoverProps}>
      <div className='flex flex-col space-y-md'>
        <ToggleComponent
          checked={isSharingEnabled}
          onChange={onSharingChanged}
          label={isSharingEnabled ? 'Active' : 'Inactive'}
          isNeue={true}
        />
      </div>
    </SmallPanel>
  );
};